/**
 * API ENDPOINT
 */
export const apiEndpointBaseUrl = 'https://adc.gmts.eplatform.vn'
export const apiVersion = 'v1'
export const shopUrl = 'https://shop.gmts.eplatform.vn'
